import {takeLatestF, putAll} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {GetBreedersAction, matingAction} from '../action';

function* execute(_: GetBreedersAction): SagaIterator {
    yield* put(matingAction.setLoading('breeders', true));

    const response = yield* call(Api.findAllToChoose);

    if (response.isSuccess) {
        yield* put(matingAction.getBreedersSuccess(response.data));
    } else {
        yield putAll(showBeError(response, t('mating')('loadBreederList')));
    }

    yield* put(matingAction.setLoading('breeders', false));
}

/** Saga that handles `mating/GET_BREEDERS`. */
export function* getBreedersSaga(): SagaIterator {
    yield takeLatestF('mating/GET_BREEDERS', execute);
}
